<template>
  <div>
    <div class="page-header">
      <h4 class="page-title">Account Settings</h4>
    </div>
    <app-card>
      <app-form @submit="updateAccount">
        <app-input
          rules="required|email"
          type="email"
          t-label="email"
          v-model="email"
          disabled
        />

        <app-input t-label="password" type="text" v-model="password" disabled />
        <!-- <slot name="footer">
          <app-button type="submit" t-label="save" class="float-right mr-2" disabled />
        </slot> -->
      </app-form>
    </app-card>
  </div>
</template>
<script>
import ApiService from '@/services/api.service'
import ToastService from '@/services/toast.service'

export default {
  data() {
    return {
      email: '',
      password: '',
    }
  },
  mounted() {
    const user = { ...this.$store.getters.currentUser }
    this.email = user.email
  },
  methods: {
    updateAccount() {
      ApiService.post('/user/profile', {
        email: this.email,
        password: this.password,
      }).then((data) => {
        if (data) {
          ToastService.success('Successfully saved.')
          this.password = null
        }
      })
    },
  },
}
</script>
